require("./bootstrap");

const carousels = document.querySelectorAll(".glide");

Object.values(carousels).map((carousel) => {
    let id = carousel.getAttribute("id");
    let slider;
    let slidersOptions = {
        'home-slider-header' : {
            type: 'carousel',
            autoplay: 3000,
            hoverpause: false,
        },
        'program-suggested_programs': {
                type: 'carousel',
                gap: 16,
                startAt: 0,
                perView: 1,
                    peek: {
                    before: 0,
                    after: 40
                }
        },
        'filter-status': {
                type: 'carousel',
                gap: 0,
                startAt: 0,
                focusAt: 'center',
                perView: 1,
                    peek: {
                    before: 0,
                    after: 0
                },
                rewind: 0
        },
        'etapes-projet': {
            type: "slider",
            gap: 16,
        }
    };

    if (id && id in slidersOptions) {
        slider = new Glide(carousel, slidersOptions[id]);
    } else {
        slider = new Glide(carousel, {
            type: "slider",
            gap: 0,
        });
    }

    slider.mount();
});

window.openModal = function (id) {
    document.getElementById(id).dispatchEvent(new CustomEvent("open-modal"));
};

window.scrollToProjectSection = function(e, t) {
    e.preventDefault();
    gsap.to(window, {duration: 1, scrollTo: {y: '#' + t, offsetY: 80}});
}

window.scrollToAnchor = function(e, t) {
    
    const href = t ? t : e.target.href;
    const target = href.split('#')[1]
    const element = document.getElementById(target)
    const elementPosition = element.getBoundingClientRect().top;
    const headerElerment = document.querySelector('header');
    const subNavMobile = headerElerment.querySelector('#nav-mobile');
    let headerOffset = headerElerment.offsetHeight;
    if(subNavMobile) {
        headerOffset += subNavMobile.offsetHeight;
    }
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });

    history.replaceState({}, document.title, window.location.origin + window.location.pathname + "#" + target);

    if(e) {
        e.preventDefault();
    }

    return false;
};

document.addEventListener('alpine:init', () => {
    Alpine.data('navbar', () => ({
        
        open: false,
        init() {
            console.log('toggle-navbar')
        },
        toggle() {
            this.open = ! this.open
        }
    }))
})
